/**
 * Internal formatting of process data passed down by server (so that our UI can process)
 * @param {*} process
 * @param {*} statusCode
 */
export const formatProcess = (process, statusCode) => {
  if (statusCode === 'N' || statusCode === 'P') {
    process.init = 0
  } else if (statusCode === 'C') {
    process.init = 1
  } else {
    process.init = 2
  }
  // Add in another field call downloading (a flag to indicate the start process of downloading)
  process.downloading = false
}
